export enum FormFlowFieldTypes {
    MultiItem = 'multi',
    List = 'list',
    Text = 'text',
    Number = 'number',
    Email = 'email',
    Textbox = 'textbox',
    Date = 'date',
    DateTime = 'datetime',
    DateTimePicker = 'datetimepicker',
    Checkbox = 'checkbox',
    GeoLocation = 'geolocation',
    Cron = 'cron',
    Calc = 'calc',
    File = 'file',
    LinkedRecord = 'linkedrecord',
    MultiLinkedRecord = 'multilinkedrecord',
    Lookup = 'lookup',
    Label = 'label',
    LinkedFieldTree = 'linkedfieldtree',
    SignaturePlaceholderField = 'signatureplaceholderfield',
    Escalation = 'escalation',
    SeverityMatrix = 'severitymatrix',
    SimpleUserList = 'simpleuserlist',
    ElectronicSignature = 'electronicsignature',
}
